import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/hooks/useAuth";
import { useVersionCheck } from "@/hooks/useVersionCheck";
import { UpdateBanner } from "@/components/UpdateBanner";
import StudySelector from "./pages/StudySelector";
import PregnancyIndex from "./pages/PregnancyIndex";
import PreconceptionIndex from "./pages/PreconceptionIndex";
import Followups from "./pages/Followups";
import ResultPage from "./pages/ResultPage";
import Auth from "./pages/Auth";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const AppContent = () => {
  const { newVersionAvailable, reloadApp } = useVersionCheck(10); // Check every 10 minutes

  return (
    <>
      {newVersionAvailable && <UpdateBanner onReload={reloadApp} />}
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<StudySelector />} />
          <Route path="/pregnancy" element={<PregnancyIndex />} />
          <Route path="/preconception" element={<PreconceptionIndex />} />
          <Route path="/followups" element={<Followups />} />
          <Route path="/result/:arm/:caseId" element={<ResultPage />} />
          <Route path="/auth" element={<Auth />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <TooltipProvider>
        <Toaster />
        <AppContent />
      </TooltipProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
